{
  "instances": {
    "quartz": {
      "actions": "Actions",
      "active_triggers": "Déclencheurs Actifs",
      "associated_triggers": "Déclencheurs Associés",
      "associated_with_calendar": "Associé au calendrier",
      "basic_information": "Informations de Base",
      "calendar": "Calendrier",
      "class": "Classe",
      "configuration": "Configuration",
      "cron_expression": "Expression Cron",
      "custom_trigger": "Déclencheur Personnalisé",
      "days_of_week": "Jours de la Semaine",
      "description": "Description",
      "details": "Détails",
      "disabled": "Désactivé",
      "durable": "Durable",
      "enabled": "Activé",
      "end_time": "Heure de Fin",
      "final_fire_time": "Heure du Dernier Déclenchement",
      "friday": "Vendredi",
      "group": "Groupe",
      "infinite": "Infini",
      "interval": "Intervalle",
      "job_data": "Données de la Tâche",
      "job_name": "Nom de la Tâche",
      "jobs": "Tâches",
      "key": "Clé",
      "label": "Quartz",
      "last_fire": "Dernier Déclenchement",
      "last_fire_time": "Heure du Dernier Déclenchement",
      "monday": "Lundi",
      "name": "Nom",
      "next_fire": "Prochain Déclenchement",
      "next_fire_time": "Heure du Prochain Déclenchement",
      "no": "Non",
      "no_data": "Aucune information disponible sur Quartz",
      "paused_triggers": "Déclencheurs en Pause",
      "preserve_hour_of_day": "Préserver l'Heure du Jour",
      "priority": "Priorité",
      "recovery": "Récupération",
      "repeat_count": "Nombre de Répétitions",
      "request_recovery": "Demander la Récupération",
      "saturday": "Samedi",
      "schedule_configuration": "Configuration de l'Horaire",
      "skip_day_if_hour_does_not_exist": "Ignorer le Jour si l'Heure n'Existe Pas",
      "start_time": "Heure de Début",
      "state": "État",
      "sunday": "Dimanche",
      "system_default": "Par Défaut du Système",
      "thursday": "Jeudi",
      "time_window": "Fenêtre de Temps",
      "time_zone": "Fuseau Horaire",
      "times_triggered": "Nombre de Déclenchements",
      "timing_information": "Informations de Synchronisation",
      "total": "total",
      "trigger_data": "Données du Déclencheur",
      "trigger_failed": "Erreur d'activation",
      "trigger_failed_message": "Erreur lors du déclenchement du travail: {error}",
      "trigger_failed_notification": "Erreur lors du déclenchement du travail \"{jobName}\": {error}",
      "trigger_fire_times": "Heures de Déclenchement",
      "trigger_job_now": "Déclencher la Tâche Maintenant",
      "trigger_success_message": "Travail \"{jobName}\" déclenché avec succès",
      "trigger_success_title": "Travail Déclenché",
      "triggers": "Déclencheurs",
      "tuesday": "Mardi",
      "type": "Type",
      "value": "Valeur",
      "wednesday": "Mercredi",
      "yes": "Oui"
    }
  }
}
